import { HttpClient } from "@angular/common/http";
import { Injectable, EventEmitter, Output } from "@angular/core";

import { HttpResponsesHandlersFactory, IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";
import { LoadingTime } from "./loading-time";
import { IQueryCommand } from "@features/filter";
import { PagedCrudService } from "@features/grid";


@Injectable()
export class LoadingTimeService extends PagedCrudService<LoadingTime> {
    readonly url = "api/loading-time";
    readonly entityTitle = "LoadingTime";

    // eslint-disable-next-line @angular-eslint/contextual-decorator, @angular-eslint/no-output-native
    @Output() readonly change: EventEmitter<boolean> = new EventEmitter();


    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }


    eventLoadingTime(): void {
        this.change.emit(true);
    }

    initalizeDate(): void {
        this.change.emit(false);
    }

    getAverage(filter: IQueryCommand): Promise<any> {
        return  this.handleRequest<LoadingTime>(
            this.http.get<LoadingTime>(this.url + "/get-average", { params: this.constructHttpParams(filter) }),
            this.handlersFactory.getForReadByFilter());
    }

    create(item: LoadingTime): Promise<LoadingTime> {
        return this.handleRequest<LoadingTime>(
            this.http.post<LoadingTime>(`${this.url}`, item),
            this.handlersFactory.getForCreate(this.entityTitle, <IHttpResponseHandlerSettings>{
                showSuccessMessage: false, showErrorMessage: false // We should post loading time quietly
            }));
    }
}